import { Pagination } from "services/search";

import { VehicleModelRow } from "./types";

import { DataWithPagination } from "services/api/types";
import { transformVehicleModelRow } from "./transformations";
import { paginatedApiCall } from "services/api/createApiCall";

/*---------------------------------------------------------------------------------------
  SEARCH
-----------------------------------------------------------------------------------------*/
export const getVehicleModelsAPI = async (
  vehicleManufacturerId: string,
  pagination: Pagination,
  name?: string | null
): Promise<DataWithPagination<VehicleModelRow>> => {
  let path = `/v1/catalog/vehicles/manufacturers/${vehicleManufacturerId}/models?name=`;

  if (name) path += `${name}`;

  return await paginatedApiCall(path, pagination, transformVehicleModelRow);
};
